import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Modal } from '../../elements-modal/modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../../elements-inputs/radio-group';
import { withdrawOffer, withdrawHostUpdate } from '../../../../api/api-contracts';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class WithdrawOfferModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isSubmitting: false,
      errorText: ''
    };

    this.withdrawAction = this.withdrawAction.bind(this);
    this.withdrawActionCb = this.withdrawActionCb.bind(this);
  }

  closeBehavior () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  withdrawAction (form, cb, refs) {
    const { bookingId, bookingState } = this.props;
    const payload = {
      reason: refs.radio.returnRadioGroupValue(),
      reasonId: refs.radio.returnRadioValueId()
    };

    this.setState({
      isSubmitting: true
    });

    if ('HOST_UPDATED_REQUESTED' === bookingState) {
      return withdrawHostUpdate(payload, bookingId, PSSessions.Cookies('PSAccess'), cb);
    }

    return withdrawOffer(bookingId, payload, PSSessions.Cookies('PSAccess'), cb);
  }

  withdrawActionCb (response) {
    this.setState({
      isSubmitting: false
    });

    if (200 === response.statusCode) {
      analyticsIntegrations.withdrawOfferConfirmed(response.control_id);
      this.closeBehavior();
      this.props.callback();

      return;
    }

    this.setState({
      errorText: this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.error_occurred', defaultMessage: 'An error occurred. Please refresh the page and try again.' })
    });
  }

  modalBody () {
    // if the booking state is confirmed, inquiry or request
    const { bookingState } = this.props;
    const inputData = [
      {
        ID: 'revise-offer',
        value: 'I need to revise this offer.',
        displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.need_review', defaultMessage: 'I need to revise this offer.' })
      },
      {
        ID: 'not-available',
        value: 'My space is no longer available at that time.',
        displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.space_not_available', defaultMessage: 'My space is no longer available at that time.' })
      },
      {
        ID: 'other',
        value: '',
        displayText: this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.other', defaultMessage: 'Other' }),
        collectUserInput: true
      }
    ];

    return (
      <div className="withdraw-update-modal col-xs-12" style={{ paddingBottom: 40 }}>
        <p className="gutter">
          <FormattedMessage
            id='inbox_review_offer.withdraw_offer_modal.tell_guest'
            defaultMessage="Tell the guest why you're withdrawing your offer."
          />
        </p>
        <FormBuilder
          formname="decline-update-form"
          formStyle="modal-plus"
          formInputs={ [{ custom: () => {
            return (
              <RadioGroup
                isRequired
                ref="radio"
                inputData={ inputData }
                groupName="withdraw-reason"
              />);
          } }] }
          submitAction={ this.withdrawAction }
          submitCallback={ this.withdrawActionCb }
          isButtonDisabled={ this.state.isSubmitting }
          buttonText={ this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.withdraw_button', defaultMessage: 'Withdraw' }) }
          errorText={ this.state.errorText }
          beforeCTA={
            'HOST_UPDATED_REQUESTED' === bookingState &&
            <div className="col-xs-12">
              <hr style={{ marginTop: 0 }} />
              <p>
                <FormattedMessage
                  id='inbox_review_offer.withdraw_offer_modal.after_withdraw'
                  defaultMessage="After you withdraw, your original booking will still be confirmed."
                />
              </p>
            </div>
          }
        />
      </div>
    );
  }

  render () {
    return (
      <Modal
        addCloseIcon
        show
        modalID="withdraw-offer-modal"
        modalSize="sm-size"
        modalType="standard"
        header={ this.props.intl.formatMessage({ id: 'inbox_review_offer.withdraw_offer_modal.withdraw__custom', defaultMessage: 'Withdraw offer' }) }
        body={this.modalBody()}
      />
    );
  }
}

WithdrawOfferModal.contextTypes = {
  router: PropTypes.object
};

WithdrawOfferModal.propTypes = {
  bookingId: PropTypes.string,
  callback: PropTypes.func,
  intl: intlShape
};

export default injectIntl(WithdrawOfferModal);
